import { createAction } from 'redux-actions'

export const clearWorkOrder = createAction('CLEAR_WORK_ORDER')
export const startCheckOut = createAction('START_CHECK_OUT')
export const stopCheckOut = createAction('STOP_CHECK_OUT')
